// 💾 /src/utils/getCoinIcon.ts
const baseIcons: Record<string, string> = {
  eth: "https://assets.coingecko.com/coins/images/279/large/ethereum.png",
  btc: "https://assets.coingecko.com/coins/images/1/large/bitcoin.png",
  usdt: "https://assets.coingecko.com/coins/images/325/large/tether.png",
  bnb: "https://assets.coingecko.com/coins/images/825/large/binance-coin-logo.png",
  sol: "https://assets.coingecko.com/coins/images/4128/large/solana.png",
  ada: "https://assets.coingecko.com/coins/images/975/large/cardano.png"
}

export const getCoinIcon = (symbol: string): string =>
  baseIcons[symbol.toLowerCase()] || "https://cryptoicons.cc/icons/generic.png"
